import * as React from 'react';
import { Layout } from './components/Layout';
import { FromPackageContainer } from './components/FromPackage';
import { PackagesContainer } from './components/Packages';
import { SinglePackageContainer } from './components/SinglePackage';
import { PublicationPriceContainer } from './components/PublicationPrice';
import { useSelector } from 'react-redux';
import {
  selectIsPackagesAvailable,
  selectIsPackagesVisible,
  selectIsSinglePackage,
} from '../../../../selectors/publishTerms';

export const PublicationSectionContainer = () => {
  const isSinglePackage = useSelector(selectIsSinglePackage);
  const isPackagesAvailable = useSelector(selectIsPackagesAvailable);
  const isPackagesVisible = useSelector(selectIsPackagesVisible);

  return (
    <Layout
      price={<PublicationPriceContainer />}
      fromPackage={!isSinglePackage && isPackagesAvailable && <FromPackageContainer />}
      packages={!isSinglePackage && isPackagesVisible && <PackagesContainer />}
      singlePackage={isSinglePackage && <SinglePackageContainer />}
    />
  );
};
